import {setCookie} from "./window.helpers";

export default function academyHeaderSearchComponent(){

    let search_filter_changed = false;
    let typingTimer;

    const doneTypingInterval = 1000;
    const not_found_class = 'not-found';
    const no_more_class = 'no-more';
    const loading_class = 'loading';
    const locked_class = 'locked_ui';
    const active_class = 'active';
    const search_string_cookie_name = 'search_string';


    const header_search_items_wrapper = document.querySelector('.eahs-items-wrapper');
    const header_search_field = document.getElementById('eahs-field');
    const header_academy_more_div = document.getElementById('eahs-more');
    const header_academy_search_string = document.getElementById('eahs-string');
    const header_academy_items = document.getElementById('eahs-items');

    if (!header_search_field) {
        return;
    }

    let header_search_field_value = header_search_field.value ?? '';

    if(header_search_field && header_search_field.value) {
        header_search_field.value = '';
    }

    const searchCTA = document.getElementById('search-cta');
    if (searchCTA) {
        searchCTA.addEventListener('click', function () {
            document.body.classList.add('ac-search_active');
            header_search_field.focus();
        });
    }

    function attach_mixpanel_tracker() {
        etoroTracking.track_link("[data-mixp]:not([x-bind])",'Academy - Click', function () {
            return {
                Location: this.getAttribute('data-location'),
                ClickedOn: this.getAttribute('data-mixp'),
                LinkTitle: this.getAttribute('data-title'),
                LinkUrl: this.getAttribute('data-url')
            };
        });
    }


    function academy_get_filtered_results(e) {
        if (typeof e !== 'undefined') {
            e.preventDefault();
        }
        if (!search_filter_changed) {
            return;
        }

        let formData = {
            header : 1,
            language : academy.lang,
            page_id : academy.page_id,
        };

        if (search_filter_changed) {
            formData.search_filter_changed = true;
        }

        if (header_search_field && header_search_field.value) {
            formData.search_input = header_search_field.value;
        }

        header_academy_more_div.className = 'eahs-more ' + loading_class;

        const searchParams = new URLSearchParams(formData);

        const xhr = new XMLHttpRequest();
        xhr.open("GET", "/wp-content/themes/etoro/cached-ajax/academy.php?" + searchParams.toString());
        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.onload = function () {
            if (xhr.status === 200) {
                try {
                    const data = JSON.parse(xhr.responseText);

                    search_filter_changed = false;

                    const count = data.count + data.courses_count;

                    if (count > 0) {
                        header_academy_more_div.classList.remove(not_found_class);
                        header_academy_items.innerHTML = '';
                    }

                    if (count === 0) {
                        header_academy_items.innerHTML = '';
                        header_academy_more_div.classList.add(not_found_class);
                    }

                    if (data.html) {
                        header_academy_items.innerHTML = data.html;
                        header_academy_search_string.innerHTML = header_search_field.value;

                        setCookie(search_string_cookie_name, header_search_field.value, 1);

                        attach_mixpanel_tracker();

                    }
                } catch (e) {
                    console.log(e);
                }

            }

            header_academy_more_div.classList.remove(loading_class);
            header_academy_items.classList.remove(locked_class);
        };

        xhr.send();
    }

    let prevSearchInputValue = (header_search_field) ? header_search_field.value : '';

    function removeParamFromURL() { //@TODO: ask Evhenii why we need this
        const urlObj = new URL( window.location );
        if ( ! urlObj.search ) {
            return;
        }
        urlObj.search = '';
        window.history.replaceState( null, null, urlObj.toString() );
    }

    function run_search() {
        search_filter_changed = true;
        removeParamFromURL();
        header_academy_items.classList.add(locked_class);
        clearTimeout(typingTimer);
        typingTimer = setTimeout(academy_get_filtered_results, doneTypingInterval);
    }

    header_search_field.addEventListener('keyup', function () {
        header_search_items_wrapper.classList.add(active_class);
        header_search_field.classList.add(active_class);
        if (prevSearchInputValue === header_search_field.value) {
            header_academy_items.classList.remove(locked_class);
            return;
        }

        if (header_search_field.value === '') {
            this.classList.remove(active_class);
            header_academy_items.innerHTML = '';
            header_academy_more_div.classList.add(no_more_class);
            header_academy_more_div.classList.remove(not_found_class);
            return;
        }
        prevSearchInputValue = header_search_field.value;
        run_search();
    });

    header_search_field.addEventListener('focusout', function () {
        const header_search_field_trim_value = header_search_field.value.trim();

        if (header_search_field_trim_value.length > 0 && header_search_field_value !== header_search_field_trim_value) {
            header_search_field_value = header_search_field_trim_value;
            etoroTracking.track('Academy Search', { SearchFor: header_search_field_trim_value });
        }
    });

    header_search_field.addEventListener('keydown', function () {
        clearTimeout(typingTimer);
    });

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' && header_search_field.classList.contains(active_class) && header_search_field.value) {
            setCookie(search_string_cookie_name, header_search_field.value, 1);
            go_to_all_search_results(e);
        }
    });

    const header_search_input_clear = document.getElementById('eahs-clear');

    function headerSearchInputClear(e) {
        e.preventDefault();
        clearTimeout(typingTimer);

        header_academy_items.innerHTML = '';
        header_academy_more_div.classList.add('hidden');

        if (header_search_field.value) {
            header_search_field.value = '';
            return;
        }

        header_search_items_wrapper.classList.remove(active_class);
        document.body.classList.remove('ac-search_active');
        header_search_field.classList.remove(active_class);
    }

    header_search_input_clear.addEventListener('click', headerSearchInputClear);
    document.querySelector('.close-menu[aria-controls="main-navigation"]').addEventListener('click', headerSearchInputClear);

    function go_to_all_search_results(e) {
        e.preventDefault();
        const language = getCurrentLang();
        const currentLanguagePath =  language !== 'en' ? '/' + language : '';

        window.location.href = window.location.origin + currentLanguagePath + '/academy/academy-search/';
    }

    const header_academy_search_all = document.getElementById('e-ac-search-all-ac-items');

    header_academy_search_all.addEventListener('click', function(e) {
        etoroTracking.track('Academy - Click', {ClickedOn:"show-more-on-search-page"});
        go_to_all_search_results(e);
    });

};